import axios from "axios";
import { url } from "../utils/constants";
import store from "../store";
import { isDevelopment, mockTokens } from "../utils/dev-env";

export async function generateTokens(contact) {
  // Em ambiente de desenvolvimento, retornar um token fixo sem enviar email
  if (isDevelopment && mockTokens.enabled) {
    // Apenas logar os tokens no console em vez de enviar por email/SMS
    mockTokens.logTokenInfo(contact);
    
    // Retornar um ID fixo para o contato, simulando a resposta do servidor
    return "dev-contact-id-123456";
  }
  
  // Em ambiente de produção, continuar usando a API real
  const res = await axios.post(`${url}/GetToken`, {
    contact,
  });

  if (res.status == 200) {
    return res.data.d;
  }

  return null;
}

export async function validateTokens(tokens) {
  // Em ambiente de desenvolvimento, validar os tokens mockados
  if (isDevelopment && mockTokens.enabled) {
    const mockTokensData = mockTokens.getTokens();
    
    // Validar se os tokens inseridos correspondem aos tokens de desenvolvimento
    const isEmailValid = tokens.email === mockTokensData.emailToken;
    const isSmsValid = tokens.sms === mockTokensData.smsToken || tokens.sms === ''; // SMS é opcional
    
    // Logar resultado da validação
    console.log('[DEV] Token Validation:', { 
      emailValid: isEmailValid, 
      smsValid: isSmsValid,
      captchaValid: !!tokens.captcha
    });
    
    // Para ambiente de desenvolvimento, apenas o token de email e captcha são necessários
    return isEmailValid && tokens.captcha;
  }
  
  // Em ambiente de produção, continuar usando a API real
  const res = await axios.post(`${url}/ValidateTokens`, {
    token: {
      EmailToken: tokens.email,
      SmsToken: tokens.sms,
      ContactoId: store.getters.getComunicateId,
      CaptchaToken: tokens.captcha,
    },
  });

  if (res.status == 200) {
    return res.data.d;
  }

  return false;
}
